import { render, staticRenderFns } from "./bianti.vue?vue&type=template&id=584bcaf2&scoped=true"
import script from "./bianti.vue?vue&type=script&lang=js"
export * from "./bianti.vue?vue&type=script&lang=js"
import style0 from "./bianti.vue?vue&type=style&index=0&id=584bcaf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584bcaf2",
  null
  
)

export default component.exports